import { Link } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Logo } from "../../components/site/Logo";

export const AuthShell = ({ title, subtitle, children, testid }) => (
  <main className="grid min-h-screen bg-[var(--paper)] lg:grid-cols-2">
    <meta name="robots" content="noindex" />
    <div className="relative hidden overflow-hidden bg-[var(--forest)] lg:block">
      <img src="/img/fence-hills.jpg" alt="Chain link fence across hilly forest land" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="relative flex h-full flex-col justify-between p-12 text-white">
        <Link to="/" data-testid="auth-home-link"><Logo light /></Link>
        <div>
          <p className="eyebrow text-[#E9C7B9]">For tender reviewers</p>
          <p className="mt-4 max-w-md font-display text-5xl font-extrabold uppercase leading-[0.95]">Track certificate requests and download our documents</p>
        </div>
      </div>
    </div>
    <div className="flex items-center justify-center px-5 py-16">
      <div data-testid={testid} className="w-full max-w-md">
        <Link to="/" className="mb-10 block lg:hidden"><Logo /></Link>
        <h1 className="font-display text-5xl font-extrabold uppercase">{title}</h1>
        {subtitle && <p className="mt-3 text-[var(--muted-ink)]">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </main>
);

export const Field = ({ id, label, ...props }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-xs uppercase tracking-wider">{label}</Label>
    <Input id={id} required className="h-11 rounded-none border-black/20 bg-white" {...props} />
  </div>
);

export const FormError = ({ error }) => error ? <p data-testid="auth-error" className="border-l-4 border-red-700 bg-red-50 p-3 text-sm text-red-800">{error}</p> : null;
